import { config } from './config';

// Os eventos e parâmetros da medição de antes (utilidades/medicao.js do v1), para comparar v1 e v2 no GA4, mais FCP, TTFB e
// o tipo de navegação. O gtag() só é definido quando o GA4 está ligado (fora do ambiente local). No hotsite estes não saem, como
// na v1: o gtag lá é compartilhado com as tags da empresa, e os eventos sem send_to iriam também para o GA dela. As conversões
// abaixo saem também no hotsite, como as do utilidades/trackEventos.js da v1.
export function registrarEvento(nome, parametros = {}) {
    if (typeof window.gtag === 'function' && !config().hotsite) {
        window.gtag('event', nome, parametros);
    }
}

// Conversões no Google Ads e no Meta Pixel, com os mesmos IDs do v1 (utilidades/trackEventos.js).
function _registrarConversao(anuncio, evento, eventoPixel) {
    if (typeof window.gtag === 'function') {
        window.gtag('event', 'conversion', { send_to: anuncio });
        window.gtag('event', evento);
    }
    if (typeof window.fbq === 'function') {
        window.fbq('trackCustom', eventoPixel);
    }
}

export function registrarConversaoCandidatura() {
    _registrarConversao('AW-16835762258/pRG6CM_Lrr4bENKw9ds-', 'lead_candidato_vaga', 'Lead candidato vaga');
}

// Conta criada no cartão ou cadastro pendente concluído (o painel-cadastrar.js do v1 disparava nos dois).
export function registrarConversaoCadastro() {
    _registrarConversao('AW-16835762258/0SodCMm0_LkbENKw9ds-', 'lead_cadastro_cv', 'Lead cadastro cv');
}

export async function iniciarMedicaoPagina(tipoPagina) {
    if (typeof window.gtag !== 'function' || config().hotsite) {
        return;
    }
    // Uma medição por página: a casca (candidato-v2.js) mede no load só as telas que não chamaram esta função.
    if (window.medicaoV2Iniciada) {
        return;
    }
    window.medicaoV2Iniciada = true;

    document.addEventListener('click', e => {
        if (e.target.closest('[data-medir="empresas"]')) {
            registrarEvento('clique_empresas', { origem: e.target.closest('[data-medir]').dataset.origem || 'rodape', tipo_pagina: tipoPagina });
        }
    });

    let webVitals;
    try {
        webVitals = await import('web-vitals');
    } catch {
        // Chunk que não baixou não pode virar erro na página.
        return;
    }

    // tipo_navegacao (prerender, back-forward-cache...) e tipo_entrega (navigational-prefetch): o efeito da pré-carga e do
    // voltar instantâneo do app aparece nos mesmos eventos.
    const entrega = performance.getEntriesByType?.('navigation')?.[0]?.deliveryType || '';
    const enviar = ({ name, delta, value, id, rating, navigationType }) => window.gtag('event', name, {
        value: Math.round(name === 'CLS' ? delta * 1000 : delta),
        metric_id: id,
        metric_value: value,
        metric_delta: delta,
        metric_rating: rating,
        tipo_pagina: tipoPagina,
        tipo_navegacao: navigationType,
        tipo_entrega: entrega,
        non_interaction: true
    });

    webVitals.onCLS(enviar);
    webVitals.onINP(enviar);
    webVitals.onLCP(enviar);
    webVitals.onFCP(enviar);
    webVitals.onTTFB(enviar);
}
